import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'
import { error } from 'jquery'

let serverUrl = getSecret('SERVER_URL')


export const state = {
  cached: {},
}

export const getters = {}

export const mutations = {
  EUROCOUPONS_REQUESTCOUPON(state, euroCouponsRequestCoupon) {
    state.cached = euroCouponsRequestCoupon
  },
}

export const actions = {

  init({ state, dispatch }) { },

  fetchEuroCouponsRequestCoupon(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/euro_coupons/request_coupon/${query}`).then((response) => {
      const request = response.data
      context.commit('EUROCOUPONS_REQUESTCOUPON', request)
      return request
    })
  },

  fetchEuroCouponsRequestCouponOptions(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/euro_coupons/request_coupon/options/${query}`).then((response) => {
      return response.data
    })
  },

  fetchEuroCouponsRequestCouponDetail(context, url) {
    return axios.get(url).then((response) => {
      return response.data
    })
  },

  createUpdateEuroCouponsRequestCoupon(context, formData) {
    let promise = null
    if (formData.url) {
      promise = axios.put(formData.url, formData)
    } else {
      promise = axios.post(`${serverUrl}/euro_coupons/request_coupon/`, formData)
    }
    return promise.then(
      (response) => {
        return response.data
      }
    )
  },
  manualCreateEuroCouponsRequestCoupon(context, formData) {
    let promise = null
    promise = axios.post(`${serverUrl}/euro_coupons/request_coupon/manual_create/`, formData)
    return promise.then(
      (response) => {
        return response
      }
    )
  },

  manualCreateInternalEuroCouponsRequestCoupon(context, formData) {
    let promise = null
    promise = axios.post(`${serverUrl}/euro_coupons/request_coupon/manual_create_internal/`, formData)
    return promise.then(
      (response) => {
        return response.data
      }
    )
  },

  manualDeleteEuroCouponsRequestCoupon(context, formData) {
    let promise = null
    promise = axios.delete(`${serverUrl}/euro_coupons/request_coupon/manual_delete/`, formData)
    return promise.then(
      (response) => {
        return response
      }
    )
  },
  manualDeleteInternalEuroCouponsRequestCoupon(context, formData) {
    let promise = null
    promise = axios.delete(`${serverUrl}/euro_coupons/request_coupon/manual_delete_internal/`, formData)
    return promise.then(
      (response) => {
        return response
      }
    )
  },
  deleteEuroCouponsRequestCoupon(context, permUrl) {
    let promise = null
    promise = axios.delete(permUrl)
    return promise.then(
      (response) => {
        return response.data
      }
    )
  },
  fetchDownloadReport(context, payload) {
    return axios.get(`${serverUrl}/euro_coupons/request_coupon/get_general_report/${payload.query}`, payload.type).then((response) => {
      return response
    })
  },

  sendGeneralReportRequestCoupon(context, payload) {
    return axios.get(`${serverUrl}/euro_coupons/request_coupon/send_general_report/${payload.query}`).then((response) => {
      return response
    })
  },

  getReportEuroCouponsRequestCoupon(context, payload) {
    return axios.get(`${payload.url}get_report/`, payload.type).then((response) => {
      return response.data
    })
  },

  sendReportEuroCouponsRequestCoupon(context, url) {
    return axios.get(`${url}send_report/`).then((response) => {
      return response.data
    })
  },
}